import IComic from '#/types/comics';
import {
  ComicDetailsActionType,
  TComicDetailsActions,
} from '../actions/comicDetails';

interface IState {
  comic: IComic | undefined;
}

const initialState: IState = {
  comic: undefined,
};

const comicDetailsReducer = (
  state = initialState,
  { type, payload }: TComicDetailsActions
): IState => {
  switch (type) {
    case ComicDetailsActionType.COMIC_DETAILS_SET_COMIC_DETAILS:
      return { ...state, comic: payload };

    default:
      return state;
  }
};

export default comicDetailsReducer;
